export default __webpack_public_path__ + "static/media/Trip-Wishlist.6e34c862.png";